exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print {\n\thtml,\n\tbody,\n\t#root {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t}\n\t#header,\n\t#nav {\n\t\tdisplay: none;\n\t}\n\t* {\n\t\t-webkit-print-color-adjust: exact !important;\n\t}\n}\n@page {\n\tsize: A4;\n\tmargin: 15px;\n}\n@media print and (color) {\n\t* {\n\t\t-webkit-print-color-adjust: exact;\n\t\tprint-color-adjust: exact;\n\t}\n}\n", ""]);

// exports
